module.exports = __webpack_public_path__ + "static/media/advocacy.735ccb47.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/advocacy.png
// module id = 349
// module chunks = 0